import React from 'react';
import { Routes, Route, Outlet } from 'react-router-dom';
import { useSelector } from 'react-redux';

import Activity from './Activity';
import ActivityItem from './ActivityItem';
import ActivityForm from './ActivityForm';

export const Activities = () => {
    return (
        <>
            <Routes>
                <Route index element={<div className="error-404">There's nothing here: 404!</div>} />
                <Route path=":slug" element={<Activity />} />
                <Route path=":slug/add" element={<ActivityForm />} />
                <Route path=":slug/edit/:id" element={<ActivityForm editMode />} />
                <Route path=":slug/:id" element={<ActivityItem />} />
            </Routes>
        </>
    );
};

export default Activities;